import PointCross from 'yoda-core-components/lib/components/PointCross/PointCross';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { func, number } from 'prop-types';
import * as styles from './FloatingFilterButton.css';

const cx = classNames.bind(styles);

/* istanbul ignore next */
export class FloatingFilterButton extends Component {
    static defaultProps = {
        countOfSelectedFilters: 0,
        onClick: () => {},
    };

    static propTypes = {
        countOfSelectedFilters: number,
        onClick: func,
    };

    constructor() {
        super();
        this.state = {
            floatingFilterBtn: false,
        };
    }

    beforePoint = () => {
        this.setState({ floatingFilterBtn: false });
    };

    afterPoint = () => {
        this.setState({ floatingFilterBtn: true });
    };

    render() {
        const { floatingFilterBtn } = this.state;
        const { countOfSelectedFilters, onClick } = this.props;
        const filterButtonWrapperClasses = [
            'bg-white-100',
            'border-1',
            'border-gray-200',
            'border-solid',
            'fixed',
            'font-open-sans-bold',
            'p-1',
            'rounded-small',
            'shadow-medium',
            'text-gray-600',
            cx('floating-filter-button'),
        ].join(' ');

        return (
            <>
                {floatingFilterBtn && (
                    <button
                        className={filterButtonWrapperClasses}
                        data-automation-id="floating-filter-button"
                        onClick={onClick}
                        type="button"
                    >
                        Filter
                        {countOfSelectedFilters > 0 && ` (${countOfSelectedFilters})`}
                    </button>
                )}
                <PointCross
                    beforePoint={this.beforePoint}
                    afterPoint={this.afterPoint}
                    topOffset="-45"
                />
            </>
        );
    }
}

const mapStateToProps = (store) => ({
    countOfSelectedFilters: store.countOfSelectedFilters,
});

export default connect(mapStateToProps)(FloatingFilterButton);
